export const uploadFileToBucket = async (file: File, token: string) => {
  try {
    // Validate file
    if (!file) {
      throw new Error('No file provided');
    }

    // Create FormData
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);

    // Prepare headers
    const headers: any = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Make the upload request
    const response = await fetch(
      'https://hrx-api.retail-x.org/api/v1/data-dump/upload-File',
      {
        method: 'POST',
        headers: headers,
        body: formData,
      },
    );

    // Parse response
    const data = await response.json();

    // Check if request was successful
    if ((data.status as string) !== 'success') {
      throw new Error(
        data.message || `Upload failed with status ${response.status}`,
      );
    }

    // Return success with full file URL
    return {
      success: true,
      url: `https://staging-hrxbackenddata.sgp1.digitaloceanspaces.com/${data?.file?.url}`,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Upload failed',
    };
  }
};
